<template>
  <router-view/>
</template>

<style>
html,body,#app{
  height: 100%;/*填充满垂直空间，与父的垂直空间高度一致*/
}
.app-container{
  padding:20px;/*元素的上、下、左、右四个方向的内边距均为 20 像素*/
}
</style>

<script setup>

</script>